<script>
    export let sentiment;
    export let sentimentReason;
</script>

<div class="bg-blueish-black border-4 rounded-lg left-10 space-x-2 p-3">
    <div class="font-bold text-2xl pl-2 uppercase {sentiment === 'POSITIVE' ? 'text-green' : 'text-red'}">{ sentiment }</div>
    <div class="text-white pt-3">{ sentimentReason }</div>
</div>
